module.exports = __webpack_public_path__ + "static/img/新闻动态-最新动态.f19032e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/about_article/新闻动态-最新动态.png
// module id = 648
// module chunks = 1